import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { tableCell as styles } from '../../static/styles';

const CandidatesTableCell = ({
  classes,
  children,
  visible,
  listCell,
  align = 'left',
  onClick,
}) => (
  <TableCell
    align={align}
    className={classNames(
      visible ? classes.visible : classes.hidden,
      classes.root,
      listCell ? classes.listCell : '',
      { [classes.clickable]: !!onClick },
    )}
    onClick={onClick}
  >
    {children}
  </TableCell>
);

CandidatesTableCell.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  visible: PropTypes.bool,
  listCell: PropTypes.bool,
  align: PropTypes.string,
  onClick: PropTypes.func,
};

export default withStyles(styles)(CandidatesTableCell);
